"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", "; \n  display: table-cell;\n  padding-right: ", ";\n  width: calc(100% / ", ");\n\n  &:last-child {\n    padding-right: 0;\n  }\n\n  .Column__list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    width: 100%;\n  }\n\n  .Column__title {\n    color: ", ";\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    margin: 0;\n    padding: 0 0 ", " 0;\n    word-break: break-all;\n  }\n\n  .Column__item {\n    font-size: 0.875rem;\n    line-height: 1.43;\n    padding-bottom: ", ";\n  }\n\n  .Column__link {\n    color: ", "; \n    text-decoration: none;\n\n    &:hover {\n      color: ", ";\n    }\n  }\n"], ["\n  color: ", "; \n  display: table-cell;\n  padding-right: ", ";\n  width: calc(100% / ", ");\n\n  &:last-child {\n    padding-right: 0;\n  }\n\n  .Column__list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    width: 100%;\n  }\n\n  .Column__title {\n    color: ", ";\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    margin: 0;\n    padding: 0 0 ", " 0;\n    word-break: break-all;\n  }\n\n  .Column__item {\n    font-size: 0.875rem;\n    line-height: 1.43;\n    padding-bottom: ", ";\n  }\n\n  .Column__link {\n    color: ", "; \n    text-decoration: none;\n\n    &:hover {\n      color: ", ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.gray.s700;
}, function (_a) {
    var theme = _a.theme;
    return theme.space.s300;
}, function (_a) {
    var nbColumns = _a.nbColumns;
    return nbColumns;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray.s800;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.body.boldTextMain.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.body.boldTextMain.fontSize;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.body.boldTextMain.fontWeight;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.body.boldTextMain.lineHeight;
}, function (_a) {
    var theme = _a.theme;
    return (theme.space.s200);
}, function (_a) {
    var theme = _a.theme;
    return (theme.space.s100);
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray.s700;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.main.base;
});
exports.Wrapper.displayName = 'ColumnBlock';
var templateObject_1;
